<template>
    <div class="ideal-payment-container">
        <div v-if="invoice">
            <b-row align-h="center">
                <b-col>
                    <h1 style="color: white" v-if="!['canceled', 'expired'].includes(status)" v-translate>{{ $gettext('Thank you!') }}</h1>
                    <h1 style="color: white" v-if="['canceled', 'expired'].includes(status)" v-translate>{{ $gettext('Oops!') }}</h1>

                    <b-card>
                        <div class="info-text">
                            <translate v-if="status === 'paid'">The invoice is paid</translate>
                            <translate v-if="status === 'canceled'">Payment failed</translate>
                            <translate v-if="status === 'expired'">Payment expired</translate>
                            <translate v-if="!['paid', 'canceled', 'expired'].includes(status)">We are working on processing your invoice payment</translate>
                        </div>

                        <AnimationItem v-if="status === 'paid'"
                            :animation="{ animationData: paymentSuccessAnimation.default, loop: false }" 
                            style="max-width: 8rem;" />
                        
                        <AnimationItem v-if="status === 'canceled'"
                            :animation="{ animationData: paymentErrorAnimation.default, loop: false }" 
                            style="max-width: 8rem;" />
                        
                        <AnimationItem v-if="status !== 'paid' && status !=='canceled'"
                            :animation="{ animationData: paymentPendingAnimation.default, loop: false }" 
                            style="max-width: 6rem; margin-bottom: 1rem;" /> <!-- includes payment expired -->

                        <p class="field-container"><strong v-translate>Invoice Number:</strong> {{ invoice.number }}</p>
                        <p class="field-container"><strong v-translate>Invoice Amount:</strong> {{ invoice.total_amount | currency('EUR', 2)}}</p>

                        <span v-if="repayLink">
                            <translate>You can try again to pay this invoice by clicking</translate>
                            <a :href="repayLink" class="payment-link"><translate> this link.</translate></a>
                        </span>
                    </b-card>
                </b-col>

                <b-col cols="9">
                    <div class="pdf-preview-wrap">
                        <iframe class="pdf-preview" v-if="invoice" :src="invoice.pdf_file"></iframe>
                    </div>
                </b-col>
            </b-row>
        </div>

        <div v-if="!invoice && !loading">
            <h1 v-translate>Oops this payment request does not seem to exist</h1>
            <div v-translate>Please contact the company that send you this link and report that you received this broken link.</div>
        </div>
    </div>
</template>

<script>
import MollieService from '@/store/services/idealpayment.service.js'
import * as paymentSuccessAnimation from '@/css/animations/payment-complete.json'
import * as paymentErrorAnimation from '@/css/animations/payment-error.json'
import * as paymentPendingAnimation from '@/css/animations/payment-pending.json'
import AnimationItem from '@/components/dashboard/ui/AnimationItem.vue'

export default {
    name: "MolliePaymentComplete",
    components: { AnimationItem },
    data() {
        return {
            invoice: null,
            status: null,
            repayLink: null,
            loading: true,
            paymentSuccessAnimation: paymentSuccessAnimation,
            paymentErrorAnimation: paymentErrorAnimation,
            paymentPendingAnimation: paymentPendingAnimation
        }
    },
    created() {
        let uuid = this.$route.params['uuid']
        
        MollieService.gekkoPaymentComplete(uuid).then((response) => {
            this.invoice = response.data.invoice
            this.status = response.data.status
            this.repayLink = response.data.repay_link
            this.loading = false
        }).catch(() => {this.loading = false})
    }
}
</script>

<style lang="scss" scoped>
.field-container {
    margin-bottom: 10px;
}

.pdf-preview-wrap {
    padding: 0;
    padding-top: 1rem;
    aspect-ratio: 1/1.4142;
    max-width: 800px;
    margin: 0 auto;
}

.pdf-preview {
    height: 100%;
    width: 100%;
    border: 0;
    transition: opacity 0.3s ease;
}

.ideal-payment-container {
    padding: 1rem;
    color: #ffffff;

    .row {
        color: #000000;
    }
}

.info-text {
  font-style: italic;
  color: $colorTextSemi;
  font-size: 14px;
  margin-bottom: 1rem;
}

.payment-link {
    color: $colorBrand;
}

.payment-link:hover {
    text-decoration: underline;
    cursor: pointer;
}
</style>